import { ExportTypes as SharedExportTypes } from '@shared/export-types';

// Extends the shared, backend-recognized export types with 'projectgebied', a
// frontend-only export flow that is sent to a separate endpoint and never
// travels over the wire as an ExportTypes value.
export const ExportTypes = {
  ...SharedExportTypes,
  projectgebied: 'projectgebied',
} as const;

export type ExportTypes = (typeof ExportTypes)[keyof typeof ExportTypes];

export const ExportFormats = {
  DWG: 'DWG',
  DXF: 'DXF',
  Shapefile: 'Shapefile',
  GeoPackage: 'GeoPackage',
  'ESRI File Geodatabase': 'ESRI File Geodatabase',
  KML: 'KML',
  'Oorspronkelijke melding': 'Oorspronkelijke melding',
  Excel: 'Excel',
  PDF: 'PDF',
  'WMS/WFS': 'WMS/WFS',
} as const;

export type ExportFormats = (typeof ExportFormats)[keyof typeof ExportFormats];

export type ExportVeiligGravenContent =
  | 'risicoinventarisatie'
  | 'beheersmaatregelen'
  | 'evs'
  | 'proefsleuven'
  | 'werkinstructies'
  | 'afwijkende-situaties'
  | 'graafschades'
  | 'aantekeningen'
  | 'gebruikerslogs'
  | 'dossier';

export { ExportConfigurations } from '@shared/export-types';
export type { ExportConfiguration } from '@shared/export-types';

export const ExportFilters = [
  {
    name: 'punten',
    alias: 'Puntobjecten',
    defaultValue: true,
  },
  {
    name: 'lijnen',
    alias: 'Lijnobjecten',
    defaultValue: true,
  },
  {
    name: 'vlakken',
    alias: 'Vlakobjecten',
    defaultValue: true,
  },
  {
    name: 'topo',
    alias: 'Topografische ondergrond',
    defaultValue: true,
  },
  {
    name: 'extra_detail',
    alias: 'Extra details',
    defaultValue: true,
  },
  {
    name: 'annotatie',
    alias: 'Annotatie en maatvoering objecten',
    defaultValue: false,
  },
  {
    name: 'ontwerp',
    alias: 'Ontwerplaag',
    defaultValue: false,
  },
] as const;

export type ExportFilter = (typeof ExportFilters)[number]['name'];
